import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDashboardTab } from '@/context/DashboardTabContext';
import { type DashboardType, DASHBOARD_ROUTES } from '@/lib/constants/dashboard';

/**
 * Replaces the repeated `navigate('/dashboard'); setBusinessDashboardTab('reviews')` pattern.
 *
 * Usage:
 *   const navigateToTab = useNavigateToTab();
 *   navigateToTab('business', BusinessTabs.REVIEWS);
 */
export function useNavigateToTab() {
  const navigate = useNavigate();
  const {
    setBusinessDashboardTab,
    setEmployeeDashboardTab,
    setEmployeePortalTab,
    setFranchiseDashboardTab,
  } = useDashboardTab();

  return useCallback((dashboard: DashboardType, tab: string) => {
    navigate(DASHBOARD_ROUTES[dashboard]);
    switch (dashboard) {
      case 'business':
        setBusinessDashboardTab(tab);
        break;
      case 'employee':
        setEmployeeDashboardTab(tab);
        break;
      case 'employee-portal':
        setEmployeePortalTab(tab);
        break;
      case 'franchise':
        setFranchiseDashboardTab(tab);
        break;
    }
  }, [navigate, setBusinessDashboardTab, setEmployeeDashboardTab, setEmployeePortalTab, setFranchiseDashboardTab]);
}
